import { useEffect, useState } from "react"
import {
  SearchField,
  View,
} from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"

export function GlobalSearch() {
  const [submittedText, setSubmittedText] = useState("")

  useEffect(() => {
    console.log(submittedText)
  }, [submittedText])

  return (
    <View
      marginX="size-100"
      marginY="size-100"
      overflow="hidden"
      UNSAFE_className="lg:w-0 sm:w-auto"
    >
      <SearchField
        inputMode="search"
        value={submittedText}
        aria-autocomplete="list"
        labelPosition="side"
        aria-label="Search"
        onChange={setSubmittedText}
        autoFocus={true}
      />
    </View>
  )
}
